import React from 'react';

import {Button, Icon, IconData} from '@gravity-ui/uikit';

import {block} from '../cn';

import {
    DefaultDropdownAvatarProps,
    UserDropdownAvatar,
} from './UserDropdownAvatar/UserDropdownAvatar';
import {UserDropdownUser} from './UserDropdownUser/UserDropdownUser';
import {defaultProps} from './constants';
import i18n from './i18n';
import {UserMenuProps} from './types';
import {getPassportAuthHref, getUserDescription, getUserName, isUserSignIn} from './utils';

import signInIcon from '../../../assets/icons/sign-in.svg';

import './UserMenuView.scss';

const b = block('user-menu-view');

export interface UserMenuViewProps
    extends Pick<
        UserMenuProps,
        'user' | 'internal' | 'compact' | 'size' | 'currentOrgId' | 'showUserInfo'
    > {
    onClick?: DefaultDropdownAvatarProps['onClick'];
    signInUrl?: string;
    menuOpen?: boolean;
    menuId?: string;
    organizationIcon?: IconData;
    organizationIconSize?: number;
}

export const UserMenuView = React.forwardRef<HTMLElement, UserMenuViewProps>(function UserMenuView(
    {
        user,
        internal,
        compact = defaultProps['compact'],
        size = defaultProps['size'],
        onClick,
        currentOrgId,
        signInUrl,
        showUserInfo = defaultProps['showUserInfo'],
        menuOpen,
        menuId,
        organizationIcon,
        organizationIconSize,
    },
    ref,
) {
    const ariaAttributes = {
        'aria-haspopup': true,
        'aria-expanded': menuOpen,
        'aria-controls': menuId,
    };

    if (isUserSignIn(user)) {
        const name = user && getUserName(user);

        if (showUserInfo && user) {
            const description = getUserDescription(user);

            return (
                <UserDropdownUser
                    ref={ref as any}
                    user={user}
                    name={name}
                    description={description}
                    size={size}
                    className={b()}
                    onClick={onClick}
                    ariaAttributes={ariaAttributes}
                />
            );
        }

        return (
            <UserDropdownAvatar
                ref={ref as any}
                user={user}
                size={size}
                internal={internal}
                federation={user?.isFederationUser}
                onClick={onClick}
                currentOrgId={currentOrgId}
                ariaAttributes={ariaAttributes}
                title={name}
                organizationIcon={organizationIcon}
                organizationIconSize={organizationIconSize}
            />
        );
    }

    const buttonChildren = [<Icon key="icon" data={signInIcon} size="18" />];

    if (!compact) {
        buttonChildren.push(<span key="text">{i18n('label_login')}</span>);
    }

    return (
        <Button
            ref={ref as any}
            view="outlined"
            size="l"
            href={signInUrl ?? getPassportAuthHref(internal)}
        >
            {buttonChildren}
        </Button>
    );
});
